import React from "react";

import { selectComparator, selectMonthPeriodLabel, selectNumberOfPeriods, selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const comparator = useAppSelector(selectComparator);
    const store = useAppSelector(selectStore);
    const numberOfPeriods = useAppSelector(selectNumberOfPeriods);
    const monthPeriodLabel = useAppSelector(selectMonthPeriodLabel);

    return (
        <>
            Analyse your {store?.name} store's gross profit margin (%) in the last {numberOfPeriods} {monthPeriodLabel}s
            and assess its position compared to {comparator?.name}. Understand whether the margin was behind, in line with,
            or ahead of the pack to inform your strategy for your {store?.name} store.
        </>
    );
};

export default Subtitle;
